
<button mat-icon-button  (click)="toggleSidebar()" >
    <a  data-toggle="offcanvas" class="btn btn-link border-none" style="color: black"><mat-icon>notifications</mat-icon><small *ngIf="(messagesService.messages$ | async)?.length>0 " class="cart-value">{{(messagesService.messages$ | async)?.length }}</small></a>
</button>

<div class="overlay" *ngIf="isOpen" (click)="close()"></div>

<div class="sidebar" [ngClass]="{ 'open': isOpen }" >
    <div class="cart-sidebar-header">
        <h5>
            {{this.translate.instant('sale4you.label.notification')}}
            <span class="text-success"> ({{(messagesService.messages$ | async)?.length }})</span>
            <a (click)="close()" class="float-right">
                <i class="mdi fa fa-close"></i>
            </a>
        </h5>
    </div>

    <div class="notification-list p-2">
        <!-- Notification Card -->
        <div *ngFor="let notification of messagesService.messages$ | async"
             class="card mb-3"
             [ngClass]="{'unread': !notification.is_read, 'flagged': notification.flag}">
            <div class="card-body">
                <!-- Notification Header -->
                <div class="d-flex justify-content-between align-items-center mb-2">
                    <small class="text-muted">
                        <i class="fas fa-clock me-1"></i>
                        {{notification.timestamp | date:'short'}}
                    </small>
                    <div>
                        <i *ngIf="!notification.is_read"
                           class="fas fa-eye-slash text-warning me-2"
                           title="Unread"></i>
                        <i *ngIf="notification.flag"
                           class="fas fa-flag text-danger"
                           title="Flagged"></i>
                    </div>
                </div>

                <!-- Notification Content -->
                <p class="card-text" [class.text-muted]="notification.is_read">
                    {{notification.message}}
                </p>

                <!-- Action Link -->
                <a *ngIf="notification.link"
                   [href]="notification.link"
                   class="btn btn-sm btn-outline-primary">
                    {{this.translate.instant('sale4you.label.view_details')}}
                </a>
            </div>
        </div>
    </div>
</div>

